/**
 * Duct Fitting Tool - Fitting Placement
 * 
 * Places duct fittings (Elbows, Tees, etc.).
 */

import { v4 as uuidv4 } from 'uuid';
import { Element } from '../core/types';
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import * as THREE from 'three';

export interface DuctFittingGeometryData {
    position: [number, number, number];
    rotation: number;
}

export interface DuctFittingElement extends Element {
    category: 'Duct Fittings';
    geometryData: DuctFittingGeometryData;
}

export class DuctFittingTool extends BaseTool {
    id = 'duct_fitting';
    name = 'Duct Fitting';
    cursor = 'crosshair';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;

        const snapped = this.snapToGrid(point);
        this.createFitting(snapped);
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        const point = this.getIntersection(event);
        if (point) {
            const snapped = this.snapToGrid(point);
            this.context.appStore.setToolPreview({
                type: 'fitting_duct',
                position: snapped
            });
        }
    }

    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }

    private createFitting(point: THREE.Vector3) {
        if (!this.context) return;

        const geometryData: DuctFittingGeometryData = {
            position: [point.x, point.y, point.z],
            rotation: 0
        };

        const fitting: DuctFittingElement = {
            id: uuidv4(),
            category: 'Duct Fittings',
            type: 'Rectangular Elbow - Mitered',
            parameters: {
                'Size': '300x300 mm',
                'Angle': '90°'
            },
            constraints: [],
            geometryData
        };

        this.context.bimStore.addElement(fitting);
    }
}
